<template>
    <div
        ref="containerDropdown"
        :class="{
            searchDropDown: true,
            'searchDropDown--formInput': true,
            'searchDropDown--active': activeDropDown,
            loadingState: busy,
        }"
    >
        <div
            :class="{
                searchDropDown__content: true,
                searchDropDown__starting: starting,
            }"
        >
            <template>
                <slot />
            </template>
        </div>

        <div v-if="!canQuery" class="searchDropDown__item">
            <span>Please enter 3 or more characters</span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    props: {
        activeDropDown: { type: Boolean, default: false },
        canQuery: { type: Boolean, default: false },
        isEmpty: { type: Boolean, default: false },
        starting: { type: Boolean, default: false },
        busy: { type: Boolean, default: false },
        query: { type: String, default: '' },
    },

    computed: {
        hasNotItems() {
            return Boolean(
                this.query.length && this.isEmpty && !this.busy && this.canSearchQueryHelp
            );
        },

        ...mapState(stores.Search, ['hasTypeItemsSearch', 'canSearchQueryHelp']),
    },
};
</script>
